<template>
  <div>

    <error-dialog :status="loadPriceStatus" />

    <sign-in-dialog v-model="showSignIn" />

    <div v-if="!hideSignOut" class="d-flex flex-column align-end mb-12 mx-n3 overflow-auto">
      <v-btn
        style="text-transform: none;"
        small text
        :color="isSignedIn ? 'secondary' : 'error'"
        :disabled="disableSignOut"
        @click="showSignIn = true"
      >
        <v-icon class="mr-1" small v-html="isSignedIn ? mdiAccountCheck : mdiAccount" />
        {{isSignedIn ? global.profile.email : 'Sign in'}}
      </v-btn>

      <!-- <v-btn
        class="mx-n3"
        style="text-transform: none;"
        small text
        :color="isSignedIn ? 'secondary' : 'error'"
        @click="showSignIn = true"
      >
        <v-icon class="mr-1" small v-html="mdiCash100" />
        Apply promo code
      </v-btn> -->
    </div>

    <template v-if="itemized">
      <itemized-price class="mb-12" :itemized="itemized" />

      <div v-if="!isSignedIn" class="text-center">
        <div class="text-body-2 mb-3">Please sign in / create account to continue</div>
        <v-btn text color="primary" @click="showSignIn = true">
          <v-icon class="mr-1" v-html="mdiAccount" />
          Sign in
        </v-btn>
      </div>

      <!-- Note that we can't simply hide the payment-btns using a v-show becuase of the convoluted way we display the payment buttons therein -->
      <payment-btns
        class="mx-auto"
        v-bind:style="{ height: isSignedIn ? null : '0', overflow: isSignedIn ? null : 'hidden' }"
        :itemized="itemized"
        :metadata="metadata"
        :loading.sync="isPaymentBtnsLoading"
        :progress.sync="isPaymentInProgress"
        :is-promo-intercept-visible.sync="isPromoInterceptVisible"
        @price-update="onPriceUpdate"
        @complete="onComplete"
        @purchase-subscription="loadPrice(); $emit('purchase-subscription');"
      />
    </template>
  </div>
</template>


<script>
import ErrorDialog from '@/components/ErrorDialog.vue';
import ItemizedPrice from '@/components/ItemizedPrice.vue';
import PaymentBtns from '@/components/PaymentBtns.vue';
import SignInDialog from '@/components/SignInDialog.vue';
import { LOCALE } from '@/utils/intl.js';
import { OPError } from '@/utils/op-dev-fetch';
import { mdiAccount, mdiAccountCheck, mdiCash100, mdiDomain } from '@mdi/js';


export default {
  name: 'payment',

  components: {
    ErrorDialog,
    ItemizedPrice,
    PaymentBtns,
    SignInDialog
  },

  props: {
    metadata: Object,
    errorHandlers: { type: Object, default: () => ({}) },
    disableSignOut: Boolean,
    hideSignOut: Boolean
  },

  data() {
    return {
      showSignIn: false,
      itemized: null,
      isPaymentBtnsLoading: false,
      isPaymentInProgress: false,
      isPromoInterceptVisible: false,
      loadPriceStatus: this.$track('loadPrice')
    };
  },

  computed: {
    loadPriceParams() {
      // Note that 'user_id' is not actually a param of get-itemized-price, but we also use this computed value as a
      // trigger to reload the price
      return this.metadata ? { user_id: this.globalUserId, metadata: this.metadata, locale: LOCALE } : null;
    },

    isLoading() {
      return this.loadPriceStatus.pending || this.isPaymentBtnsLoading;
    }
  },

  created() {
    Object.assign(this, { mdiAccount, mdiAccountCheck, mdiCash100, mdiDomain });
  },

  methods: {
    async loadPrice() {
      if (this.isPromoInterceptVisible) {
        this.deferred = true;
        return;
      }
      try {
        this.itemized = await this.$call('get-itemized-price', this.loadPriceParams);
        this.$emit('update-price', this.itemized.price);
        $event.log('price-loaded', { metadata: this.metadata, ...this.itemized });
      } catch (e) {
        if ((e instanceof OPError) && (e.type == 'InvalidMetadataException') && this.errorHandlers[e.message])
          await this.errorHandlers[e.message]();
        else
          throw e;
      }
    },

    onPriceUpdate() {
      this.$confirm({
        title: 'Items have been updated',
        msg: 'These items have changed since last loaded',
        buttons: [ 'Ok' ],
        primary: 'Ok'
      });
      this.loadPrice();
    },

    onComplete(payment_id) {
      // Note that 'payment_id' may be undefined if we failed the idempotency check
      this.$emit('complete', payment_id);
      $event.log('checkout', { metadata: this.metadata, ...this.itemized, payment_id });
    }
  },

  watch: {
    loadPriceParams: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v)
          this.loadPrice();
      }
    },

    isLoading: {
      immediate: true,
      handler(v) {
        this.$emit('update:loading', v);
      }
    },

    isPaymentBtnsLoading(v) {
      if (!v && !this.didLoad) {
        this.didLoad = true;
        this.$emit('loaded');
      }
    },

    isPromoInterceptVisible: {
      immediate: true,
      handler(v) {
        this.$emit('update:is-promo-intercept-visible', v);
        if (!v && this.deferred) {
          this.deferred = false;
          this.loadPrice();
        }
      }
    }
  }
}
</script>
